'use strict';

angular
	.module('bringgApp')
	.constant('BRINGG_NOW_CHECKOUT_FLOW', {
		MERCHANT_CREATED: 4,
		ORDER_CREATED: 5,
		DRIVER_CREATED: 6,
		ORDER_ASSIGNED: 7,
		ORDER_DONE: 8
	})
	.factory('BringgNowEvents', function ($rootScope, BRINGG_NOW_CHECKOUT_FLOW) {
		var BringgNowEvents = {};

		return BringgNowEvents;
	});
